<template>
  <div>
    <HollowPie :id="id" :chartData="chartData" />
  </div>
</template>

<script>
  import HollowPie from "@/components/Echarts/Lvyouyulun/HollowPie.vue";

  export default {
    name: "Yuqingleixingfenxi",
    props: {
      chartData: {
        type: Object,
        default() {
          return {};
        }
      },id: {
        type: String,
        default: "chart"
      }
    },
    components: {
      HollowPie
    },
    data() {
      return {};
    },
    mounted() {}
  };
</script>

<style scoped lang="less"></style>
